import axios from 'axios'

const apiBaseUrl = process.env.REACT_APP_API_BASE_URL
const SLIM_USERNAME = process.env.REACT_APP_SLIM_USERNAME
const SLIM_PASSWORD = process.env.REACT_APP_SLIM_PASSWORD
const axiosConfig = {auth:{username:SLIM_USERNAME, password:SLIM_PASSWORD}}

const serverPost = (irl, indata, handleReply) => {
    const url = irl.includes(apiBaseUrl)?irl:apiBaseUrl + irl
    // alert('serverPost url:' + url + ' indata:' + JSON.stringify(indata))
    axios.post(url, indata, axiosConfig)
    .then(response => {
        const data = response.data?response.data:response
        if (data) {
            const status = data.status?data.status:'UNKOWN STATUS'
            if (status === 'OK') {
                handleReply(data);
            } else { 
                if (status === 'WARNING') {
                    handleReply(data)
                } else {
                    const defaultMessage = 'status:' + status + ' data:' + JSON.stringify(data)
                    const message = data.message?data.message:defaultMessage
                    alert(message)    
                }   
            }    
        } else {
            const message = '[serverPost] ERROR: serverPost failed. No data.' 
                + '\n\n\nurl:' + url + ' indata:' + JSON.stringify(indata);
            alert(message)
        }
    })
    .catch(e => {
        const message = 'SEVERE ERROR in function serverPost: No response from url=' + url 
        + "\n\n\nError:" + (e.message?e.message:JSON.stringify(e))
        alert(message);    
    });
}

export default serverPost;

